import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import eyebox from "../../Utils/Images/eyebox.png";
import deletebox from "../../Utils/Images/deletebox.png";
import userbox from "../../Utils/Images/Userbox.png";
import userblock from "../../Utils/Images/user block.png";
import user from "../../Utils/Images/User.png";
import { Link } from "react-router-dom";
import { GetUser } from "../../APIs/Function/User/GetUser";
import DeleteModal from "../Modal/DeleteModal";
import { handleEdituser } from "../../APIs/Function/User/EditUser";
import BlockModal from "../Modal/BlockModal";
import Loader from "../Loader/Loader";

const UserTable = ({ userData, setUserData, loading }) => {
  const [open, setOpen] = useState(false);
  const [blockOpen, setBlockOpen] = useState(false);
  const [modalID, setModalID] = useState("");
  const [blockModalID, setBlockModalID] = useState("");
  const [loadinga, setLoadinga] = useState(false);
  const [blockStatus, setBlockStatus] = useState("");
  const handleClose = () => {
    setOpen(!open);
  };
  const handleBlockClose = () => {
    setBlockOpen(false);
  };
  const handleModal = (id) => {
    setModalID(id);
    setOpen(true);
  };
  const handleBlockModal = (id, status) => {
    setBlockModalID(id);
    const newStatus = status === 1 ? -1 : 1;
    setBlockStatus(newStatus);
    setBlockOpen(true);
  };

  const handleDelete = async (modalID) => {
    setOpen(false);
    await handleEdituser(modalID, blockStatus);
    setLoadinga(true);
    let res = await GetUser();
    setLoadinga(false);
    setUserData(res.r);
    alert("User Deleted Successfully");
  };
  const handleBlock = async (blockModalID) => {
    setBlockOpen(false);
    await handleEdituser(blockModalID, blockStatus);
    {
      blockStatus != 1
        ? alert("User Blocked Successfully")
        : alert("User Unblocked Successfully");
    }
    setLoadinga(true);
    let res = await GetUser();
    setLoadinga(false);
    setUserData(res.r);
  };

  return (
    <>
      {loading ? (
        <Box>
          <Loader />
        </Box>
      ) : (
        <Box>
          {/* heading */}
          <Box
            sx={{
              boxShadow: "none",
              outline: "none",
              mb: "10px",
              border: "none",
              mt: "10px",
              boxSizing: "border-box",
            }}
          >
            <Grid container>
              {/* first column */}
              <Grid item xs={0.5} md={0.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",
                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    #
                  </Typography>
                </Paper>
              </Grid>

              {/* Second Column */}

              <Grid item xs={1.5} md={1.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Profile Photo
                  </Typography>
                </Paper>
              </Grid>

              {/* Third Column */}

              <Grid item xs={2} md={2}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      maxWidth: "100px",
                      "&:hover": {
                        overflow: "visible",
                      },
                    }}
                  >
                    Username
                  </Typography>
                </Paper>
              </Grid>

              {/* Fourth Column */}

              <Grid item xs={2} md={2}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    noWrap
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      maxWidth: "150px",
                      "&:hover": {
                        overflow: "visible",
                      },
                    }}
                  >
                    Mobile Number
                  </Typography>
                </Paper>
              </Grid>
              {/* fifth Column */}
              <Grid item xs={2} md={2.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    Email
                  </Typography>
                </Paper>
              </Grid>
              {/* Sixth Column */}
              <Grid item xs={2} md={2}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    noWrap
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      maxWidth: "150px",
                      "&:hover": {
                        overflow: "visible",
                      },
                    }}
                  >
                    User Type
                  </Typography>
                </Paper>
              </Grid>
              {/* Seventh Column */}
              <Grid item xs={2} md={1.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                    // bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                      textOverflow: "ellipsis",
                      overflow: "hidden",
                      maxWidth: "100px",
                      "&:hover": {
                        overflow: "visible",
                      },
                    }}
                  >
                    Action
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
          <Box
            sx={{
              border: "0.5px solid #DDDDDD",
              height: "100%",
              overflow: "auto",
              mt: "10px",
              borderTop: "0.5px solid #DDDDDD",
              maxHeight: "75vh",
              "&:hover": {
                "::-webkit-scrollbar": {
                  width: "5px",
                  borderRadius: "10px",
                },
                "::-webkit-scrollbar-thumb": {
                  bgcolor: "gray",
                  borderRadius: "10px",
                },
              },
            }}
          >
            <Box>
              {userData?.length ? (
                <Grid container>
                  {/* first column */}
                  <Grid item xs={0.5} md={0.5}>
                    {userData?.map((item, i) => (
                      <Paper
                        key={`column1_${item.id}`}
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",
                          }}
                        >
                          {i + 1}
                        </Typography>
                      </Paper>
                    ))}
                  </Grid>

                  {/* Second Column */}

                  <Grid item xs={1.5} md={1.5}>
                    {userData?.map((item, i) => (
                      <Paper
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                        key={`column2_${item.id}`}
                      >
                        <Box
                          sx={{
                            width: { xs: "35px", md: "50px" },
                            height: { xs: "35px", md: "50px" },
                          }}
                        >
                          <img
                            width={"100%"}
                            height={"100%"}
                            style={{ borderRadius: "10px" }}
                            src={
                              item.profile_img
                                ? `https://api-qhealth.equitysofttechnologies.com//upload/profile_img/${item.profile_img}`
                                : user
                            }
                            alt=""
                          />
                        </Box>
                      </Paper>
                    ))}
                  </Grid>

                  {/* Third Column */}

                  <Grid item xs={2} md={2}>
                    {userData?.map((item, i) => (
                      <Paper
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                        key={`column3_${item.id}`}
                      >
                        <Typography
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "90%",
                            "&:hover": {
                              overflow: "visible",
                            },
                          }}
                        >
                          {item.user_name}
                        </Typography>
                      </Paper>
                    ))}
                  </Grid>

                  {/* Fourth Column */}

                  <Grid item xs={2} md={2}>
                    {userData?.map((item, i) => (
                      <Paper
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                        key={`column4_${item.id}`}
                      >
                        <Typography
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",

                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "90%",
                            "&:hover": {
                              overflow: "visible",
                            },
                          }}
                        >
                          {item.phone_no}
                        </Typography>
                      </Paper>
                    ))}
                  </Grid>
                  {/* fifth Column */}
                  <Grid item xs={2} md={2.5}>
                    {userData?.map((item, i) => (
                      <Paper
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                        key={`column5_${item.id}`}
                      >
                        <Typography
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: "16px",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            maxWidth: "90%",
                            "&:hover": {
                              overflow: "visible",
                            },
                          }}
                        >
                          {item.email}
                        </Typography>
                      </Paper>
                    ))}
                  </Grid>
                  {/* Sixth Column */}
                  <Grid item xs={2} md={2}>
                    {userData?.map((item, i) => (
                      <Paper
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                        key={`column6_${item.id}`}
                      >
                        <Button
                          sx={{
                            fontFamily: "inter",
                            fontWeight: "400",
                            fontSize: { xs: "12px", md: "16px" },
                            width: { xs: "45px", md: "80px" },

                            bgcolor: item.type === 2 ? "#CAF1C7" : "#E6E6E6",
                            color: "black",
                            textTransform: "capitalize",
                            "&:hover": {
                              bgcolor: item.type === 2 ? "#CAF1C7" : "#E6E6E6", // Keep the same background color as normal
                            },
                          }}
                        >
                          {item.type === 1 ? "Basic" : "Premium"}
                        </Button>
                      </Paper>
                    ))}
                  </Grid>
                  {/* Seventh Column */}
                  <Grid item xs={2} md={1.5}>
                    {userData?.map((e, i) => (
                      <Paper
                        sx={{
                          border: "0.5px solid #DDDDDD",
                          borderRadius: "0px",
                          height: "70px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                          bgcolor: i % 2 === 0 ? "#FFFFFF" : "#fbfbfb",
                        }}
                        key={`column1_${e.id}`}
                      >
                        <Box
                          sx={{
                            p: "5px",
                            display: "Flex",
                            width: "100%",
                            gap: { xs: "2px", md: "5px" },
                            justifyContent: "center",
                          }}
                        >
                          <Box
                            sx={{
                              cursor: "pointer",
                              width: { xs: "50%", md: "25%" },
                              height: { xs: "50%", md: "25%" },
                            }}
                          >
                            <Link to={`/usedetails/${e.id}`}>
                              <img
                                width={"100%"}
                                height={"100%"}
                                src={eyebox}
                                alt=""
                              />
                            </Link>
                          </Box>
                          <Box
                            sx={{
                              cursor: "pointer",
                              width: { xs: "50%", md: "25%" },
                              height: { xs: "50%", md: "25%" },
                            }}
                            onClick={() => handleModal(e.id)}
                          >
                            <img width={"100%"} src={deletebox} alt="" />
                          </Box>
                          <Box
                            sx={{
                              cursor: "pointer",
                              width: { xs: "50%", md: "25%" },
                              height: { xs: "50%", md: "25%" },
                            }}
                            onClick={() => handleBlockModal(e.id, e.status)}
                          >
                            <img
                              width={"100%"}
                              src={e.status == -1 ? userblock : userbox}
                              alt="preview"
                            />
                          </Box>
                        </Box>
                      </Paper>
                    ))}
                  </Grid>
                </Grid>
              ) : (
                <Box sx={{ height: "500px", }}>
                  <Typography>No Result Found</Typography>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      )}
      <DeleteModal
        open={open}
        handleDelete={handleDelete}
        modalID={modalID}
        onClose={handleClose}
      />
      <BlockModal
        open={blockOpen}
        handleBlock={handleBlock}
        blockModalID={blockModalID}
        handleBlockClose={handleBlockClose}
        blockStatus={blockStatus}
      />
    </>
  );
};

export default UserTable;
